import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';
import vehiclesEn from './locales/fragments/vehicles.en.json';
import vehiclesZhCN from './locales/fragments/vehicles.zh-CN.json';
import driversEn from './locales/fragments/drivers.en.json';
import driversZhCN from './locales/fragments/drivers.zh-CN.json';
import complianceEn from './locales/fragments/compliance.en.json';
import complianceZhCN from './locales/fragments/compliance.zh-CN.json';
import fleetOperatorsEn from './locales/fragments/fleetOperators.en.json';
import fleetOperatorsZhCN from './locales/fragments/fleetOperators.zh-CN.json';
import fleetAvailabilityEn from './locales/fragments/fleetAvailability.en.json';
import fleetAvailabilityZhCN from './locales/fragments/fleetAvailability.zh-CN.json';
import fleetOpsRecEn from './locales/fragments/fleetOpsRec.en.json';
import fleetOpsRecZhCN from './locales/fragments/fleetOpsRec.zh-CN.json';
import organizationsEn from './locales/fragments/organizations.en.json';
import organizationsZhCN from './locales/fragments/organizations.zh-CN.json';
import operationsEn from './locales/fragments/operations.en.json';
import operationsZhCN from './locales/fragments/operations.zh-CN.json';
import dataManagementEn from './locales/fragments/dataManagement.en.json';
import dataManagementZhCN from './locales/fragments/dataManagement.zh-CN.json';
import ownerScheduleEn from './locales/fragments/ownerSchedule.en.json';
import ownerScheduleZhCN from './locales/fragments/ownerSchedule.zh-CN.json';
import ownerPendingEn from './locales/fragments/ownerPending.en.json';
import ownerPendingZhCN from './locales/fragments/ownerPending.zh-CN.json';
import ownerOrganizationsEn from './locales/fragments/ownerOrganizations.en.json';
import ownerOrganizationsZhCN from './locales/fragments/ownerOrganizations.zh-CN.json';
import tripMapEn from './locales/fragments/tripMap.en.json';
import tripMapZhCN from './locales/fragments/tripMap.zh-CN.json';
import settingsEn from './locales/fragments/settings.en.json';
import settingsZhCN from './locales/fragments/settings.zh-CN.json';
import jobFormEn from './locales/fragments/jobForm.en.json';
import jobFormZhCN from './locales/fragments/jobForm.zh-CN.json';
import mapSettingsEn from './locales/fragments/mapSettings.en.json';
import mapSettingsZhCN from './locales/fragments/mapSettings.zh-CN.json';
import dispatchRecEn from './locales/fragments/dispatchRec.en.json';
import dispatchRecZhCN from './locales/fragments/dispatchRec.zh-CN.json';
import vehicleTimelineEn from './locales/fragments/vehicleTimeline.en.json';
import vehicleTimelineZhCN from './locales/fragments/vehicleTimeline.zh-CN.json';
import remindersEn from './locales/fragments/reminders.en.json';
import remindersZhCN from './locales/fragments/reminders.zh-CN.json';
import systemConfigEn from './locales/fragments/systemConfig.en.json';
import systemConfigZhCN from './locales/fragments/systemConfig.zh-CN.json';
import rbacEn from './locales/fragments/rbac.en.json';
import rbacZhCN from './locales/fragments/rbac.zh-CN.json';

const enResources = {
  ...en,
  ...vehiclesEn,
  ...driversEn,
  ...complianceEn,
  ...fleetOperatorsEn,
  ...fleetAvailabilityEn,
  ...fleetOpsRecEn,
  ...organizationsEn,
  ...operationsEn,
  ...dataManagementEn,
  ...ownerScheduleEn,
  ...ownerPendingEn,
  ...ownerOrganizationsEn,
  ...tripMapEn,
  ...settingsEn,
  ...remindersEn,
  ...systemConfigEn,
  ...jobFormEn,
  ...mapSettingsEn,
  ...dispatchRecEn,
  ...vehicleTimelineEn,
  ...rbacEn,
};

const zhCNResources = {
  ...zhCN,
  ...vehiclesZhCN,
  ...driversZhCN,
  ...complianceZhCN,
  ...fleetOperatorsZhCN,
  ...fleetAvailabilityZhCN,
  ...fleetOpsRecZhCN,
  ...organizationsZhCN,
  ...operationsZhCN,
  ...dataManagementZhCN,
  ...ownerScheduleZhCN,
  ...ownerPendingZhCN,
  ...ownerOrganizationsZhCN,
  ...tripMapZhCN,
  ...settingsZhCN,
  ...remindersZhCN,
  ...systemConfigZhCN,
  ...jobFormZhCN,
  ...mapSettingsZhCN,
  ...dispatchRecZhCN,
  ...vehicleTimelineZhCN,
  ...rbacZhCN,
};

export const ADMIN_LANG_STORAGE_KEY = 'ubus-admin-lang';

export type AdminLanguage = 'en' | 'zh-CN';

export function readStoredAdminLanguage(): AdminLanguage {
  const raw = localStorage.getItem(ADMIN_LANG_STORAGE_KEY);
  if (raw === 'zh-CN' || raw === 'en') return raw;
  return 'en';
}

export function persistAdminLanguage(lang: AdminLanguage): void {
  localStorage.setItem(ADMIN_LANG_STORAGE_KEY, lang);
  document.documentElement.lang = lang === 'zh-CN' ? 'zh-CN' : 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enResources },
    'zh-CN': { translation: zhCNResources },
  },
  lng: typeof window !== 'undefined' ? readStoredAdminLanguage() : 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

if (typeof window !== 'undefined') {
  persistAdminLanguage(readStoredAdminLanguage());
}

export async function setAdminLanguage(lang: AdminLanguage): Promise<void> {
  persistAdminLanguage(lang);
  await i18n.changeLanguage(lang);
}

export default i18n;
